import { render, staticRenderFns } from "./HeadingDesktop.vue?vue&type=template&id=38e41459&"
import script from "./HeadingDesktop.vue?vue&type=script&lang=ts&"
export * from "./HeadingDesktop.vue?vue&type=script&lang=ts&"
import style0 from "./HeadingDesktop.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProfileCarousel: require('/Users/markussh/git/theodora-tech-website/src/components/ProfileCarousel.vue').default,SectionStartIconGroup: require('/Users/markussh/git/theodora-tech-website/src/components/section/Start/IconGroup.vue').default,IconCornerLeftDown: require('/Users/markussh/git/theodora-tech-website/src/components/icon/CornerLeftDown.vue').default,CircleButton: require('/Users/markussh/git/theodora-tech-website/src/components/button/CircleButton.vue').default,AnimateHeading: require('/Users/markussh/git/theodora-tech-website/src/components/animate/AnimateHeading.vue').default})
